var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "38px",
    viewBox: "0 0 32 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pdf") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.358,0 L32,8.026 L32,35.45408 C32,36.8601528 30.8601528,38 29.45408,38 L2.54592,38 C1.13984721,38 1.72194254e-16,36.8601528 0,35.45408 L0,2.54592 C-1.72194254e-16,1.13984721 1.13984721,-1.07397625e-15 2.54592,0 L24.358,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pdf_icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u77E9\\u5F62"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FC5C5E",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FD9899",
    mask: "url(#mask-2)",
    x: 24,
    y: -6.55172414,
    width: 12,
    height: 14.4137931,
    rx: 1.27296
  })), /*#__PURE__*/React.createElement("g", {
    id: "pdf",
    transform: "translate(4.413793, 9.771429)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 20.9450631,
    height: 20.608446
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0360265,15.3990888 C16.4651468,15.2845975 14.9524478,14.7121406 13.7306525,13.6817183 C11.3452425,14.1969295 9.07619399,14.9411233 6.8071455,15.8570543 C5.00354284,19.0055668 3.31630165,20.608446 1.86178338,20.608446 C1.57087973,20.608446 1.22179534,20.5512003 0.989072432,20.3794633 C0.349084391,20.0932348 0,19.4635323 0,18.8338298 C0,18.3186187 0.116361464,16.8874766 5.64353088,14.5404036 C6.92350696,12.2505762 7.91257938,9.90350322 8.72710962,7.44193884 C8.02894086,6.06804243 6.51624185,2.69054712 7.56349501,0.973176625 C7.91257938,0.343474107 8.61074816,-6.89726054e-15 9.36709766,0.0572456744 C9.94890496,0.0572456744 10.5307123,0.343474086 10.8797967,0.801439562 C11.6361462,1.83186186 11.5779654,4.00719783 10.588893,7.2129561 C11.5197847,8.93032659 12.74158,10.47596 14.1960983,11.7926108 C15.4178936,11.563628 16.639689,11.391891 17.8614843,11.391891 C20.5959787,11.4491366 21.0032438,12.7085417 20.9450631,13.4527356 C20.9450631,15.3990888 19.025099,15.3990888 18.0360265,15.3990888 L18.0360265,15.3990888 Z M1.74542192,18.9483212 L1.91996412,18.8910755 C2.73449435,18.6048471 3.37448239,18.0323902 3.83992822,17.2881964 C2.96721726,17.6316705 2.26904849,18.2041273 1.74542192,18.9483212 Z M9.48345911,1.77461619 L9.30891692,1.77461619 C9.2507362,1.77461619 9.13437474,1.77461619 9.07619399,1.83186186 C8.84347107,2.80503849 9.01801327,3.83546079 9.42527839,4.75139172 C9.77436278,3.77821509 9.77436278,2.74779279 9.48345911,1.77461619 L9.48345911,1.77461619 Z M9.89072424,10.0752403 L9.8325435,10.1897316 L9.77436278,10.132486 C9.2507362,11.4491367 8.6689289,12.7657874 8.02894084,14.0251924 L8.1453023,13.9679467 L8.1453023,14.0824381 C9.42527839,13.6244726 10.8216159,13.2237528 12.101592,12.9375244 L12.0434113,12.8802787 L12.2179535,12.8802787 C11.3452425,12.0215935 10.5307123,11.0484169 9.89072424,10.0752403 L9.89072424,10.0752403 Z M17.8033036,13.1092615 C17.279677,13.1092615 16.8142312,13.1092615 16.2906046,13.2237529 C16.8724119,13.5099813 17.4542192,13.6244726 18.0360265,13.6817183 C18.4432917,13.738964 18.8505568,13.6817183 19.1996412,13.5672269 C19.1996412,13.3954899 18.9669182,13.1092615 17.8033036,13.1092615 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.1ae4897163c97a90baeea001a0203b77.svg";
export { ForwardRef as ReactComponent };